import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { TrackingMetadata } from '~/services/tracking/posthog/constants';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import { ChatDeepAnalysis } from './chat-deep-analysis/ChatDeepAnalysis';
import { ChatDocumentSearch } from './chat-document-search/ChatDocumentSearch';
import { ChatInputConfig } from './types';

export interface ChatInputProps {
  submitCallback?: (message?: string) => void;
  chatContext?: {
    documents?: string[];
    documentTypes?: string[];
    entityTags?: string[];
  };
  config?: ChatInputConfig;
  trackingMetadata?: TrackingMetadata;
  usageIndicator?: ReactNode;
}

export const ChatInput = ({
  submitCallback,
  chatContext,
  config,
  trackingMetadata,
  usageIndicator,
}: ChatInputProps) => {
  useTranslation(['chat']);
  const { mode } = useChatNavigation();

  if (mode === 'document' || chatContext) {
    return (
      <ChatDocumentSearch
        config={config}
        submitCallback={submitCallback}
        chatContext={chatContext}
        trackingMetadata={trackingMetadata}
      />
    );
  }

  return (
    <ChatDeepAnalysis
      config={config}
      submitCallback={submitCallback}
      trackingMetadata={trackingMetadata}
      usageIndicator={usageIndicator}
    />
  );
};
